module.exports = __webpack_public_path__ + "img/IMG_4613.dbff0fdb.jpg";